import { Classes, Icon } from "@blueprintjs/core"
import CustomButton from "components/Atoms/CustomButton"
import StringInput from "components/Atoms/StringInput"
import CustomReactTable from "components/Templates/CustomReactTable"
import FileUploadDialog from "components/Templates/FileUploadDialog"
import {
  useResolveRemarkMutation,
  useSaveItemDetailsMutation,
} from "generated/graphql"
import React, { useEffect, useRef, useState } from "react"
import { SuccessToast } from "utils/AppToaster"
import classNames from "utils/classNames"

const ItemsTable = ({ tripId, items }) => {
  const [state, setState] = useState([])
  const [saveItemDetails] = useSaveItemDetailsMutation()
  const [resolveRemark] = useResolveRemarkMutation()
  const editableKeyToFocus = useRef(null)

  useEffect(() => {
    const bookings = items?.map(item => ({
      bookingId: item.id,
      despatchedQuantity: item.despatchedQuantity || 0,
      remark: "",
      despatchPhotoLink: [item?.despatchPhoto],
      fileUploadOpen: false,
    }))
    setState(bookings)
  }, [items])

  const renderEditableCell = ({ original, index, value: quantity }) => {
    return (
      <div key={index + "row"}>
        <div className="vt-text-center">
          <StringInput
            key={index + "input"}
            autoFocus={index + "input" === editableKeyToFocus.current}
            type="number"
            value={state?.length > 0 ? state[index]?.despatchedQuantity : 0}
            onChange={(path, value) => {
              if (value > quantity) return
              editableKeyToFocus.current = index + "input"
              const tempState = [...state]
              tempState[index].despatchedQuantity = value
              setState(tempState)
            }}
          />
        </div>
        {original.driverDespatchRemark && original.driverDespatchRemark !== "" && (
          <CustomButton
            style={{ float: "right" }}
            className="px-2 mt-2"
            intent="warning"
            text="Resolve"
            onClick={() => {
              resolveRemark({
                variables: {
                  tripId,
                  tripIdID: tripId,
                  bookings: [
                    {
                      bookingId: original?.id,
                      driverVerification: true,
                      remark: "",
                    },
                  ],
                },
              })
              SuccessToast("Success")
            }}
          />
        )}
      </div>
    )
  }

  const COLUMNS = [
    {
      Header: "Item",
      accessor: "orderItem.sellableItem",
      Cell({ value, index, original, ...props }) {
        return (
          <div>
            <div className="flex items-center">
              <FileUploadDialog
                disabled={false}
                path="photos"
                value={
                  state &&
                  state.length > 0 &&
                  state[index]?.despatchPhotoLink?.length > 0 &&
                  state[index]?.despatchPhotoLink[0]
                    ? state[index]?.despatchPhotoLink
                    : []
                }
                isOpen={
                  state && state.length > 0
                    ? state[index]?.fileUploadOpen
                    : false
                }
                onClose={() => {
                  const tempState = [...state]
                  tempState[index].fileUploadOpen = false
                  setState(tempState)
                }}
                onChange={(path, value) => {
                  const tempState = [...state]
                  tempState[index].despatchPhotoLink = value
                  setState(tempState)
                }}
              />
              <Icon
                className="ml-2"
                style={{ cursor: "pointer" }}
                icon="media"
                iconSize={25}
                intent="success"
                onClick={() => {
                  const tempState = [...state]
                  tempState[index].fileUploadOpen = true
                  setState(tempState)
                }}
              />
              <div className="ml-3">
                <div className="vt-text-center">{value.name}</div>
                <div
                  className={classNames(
                    "vt-text-left",
                    Classes.TEXT_MUTED,
                    Classes.TEXT_SMALL
                  )}
                >
                  {value.id}
                </div>
              </div>
            </div>
            {original.driverDespatchRemark &&
              original.driverDespatchRemark !== "" && (
                <div className="vt-order-dms-missing vt-text-left px-2 py-1 mt-2">
                  {original.driverDespatchRemark}
                </div>
              )}
          </div>
        )
      },
    },
    {
      minWidth: 40,
      Header: "Ordered",
      accessor: "orderItem.quantity",
      Cell({ value }) {
        return (
          <>
            <div className="vt-text-center">{`${value}`}</div>
          </>
        )
      },
    },
    {
      minWidth: 50,
      Header: "Loaded",
      accessor: "orderItem.quantity",
      Cell: renderEditableCell,
      Footer: (
        <div
          style={{
            backgroundColor: "white",
            background: "white",
            color: "white",
          }}
        >
          <CustomButton
            style={{ float: "right", marginRight: "10px" }}
            icon="confirm"
            intent="success"
            text="Save"
            onClick={() => {
              saveItemDetails({
                variables: {
                  tripId,
                  tripIdID: tripId,
                  bookings: state?.map(booking => ({
                    bookingId: booking.bookingId,
                    despatchedQuantity: booking.despatchedQuantity,
                    remark: "",
                    despatchPhotoLink:
                      booking?.despatchPhotoLink &&
                      booking?.despatchPhotoLink.length > 0 &&
                      booking?.despatchPhotoLink[0]
                        ? {
                            url: booking.despatchPhotoLink[0].url,
                            mediaType: "PHT",
                          }
                        : undefined,
                  })),
                },
              })
              SuccessToast(`Success`)
            }}
          />
        </div>
      ),
    },
  ]

  return (
    <div>
      <CustomReactTable
        className="vt-dms-react-table"
        getTrProps={(_, row) => {
          const bookingsByTrip = row?.original?.bookingsByTrip
          const count = bookingsByTrip?.filter(
            o => o.driverDespatchRemark
          ).length
          if (count > 0) {
            return {
              className: "vt-order-cancelled",
            }
          } else {
            return {
              className: "vt-order-processing",
            }
          }
        }}
        data={items}
        columns={COLUMNS}
      />
    </div>
  )
}

export default ItemsTable
